const STORAGE_KEY = "groupsSelectedYear";
const START_YEAR = 2022;

/**
 * Generate academic year options dynamically from START_YEAR to current year.
 * @param {"short"|"full"} format - "short" = "2025", "full" = "2025-2026"
 */
export function generateYearOptions(format = "short") {
  const currentYear = new Date().getFullYear();
  const options = [];
  for (let y = currentYear; y >= START_YEAR; y--) {
    options.push({
      text: `${y}-${y + 1}`,
      value: format === "full" ? `${y}-${y + 1}` : String(y),
    });
  }
  return options;
}

/** Read stored year (always short format, e.g. "2025") */
export function getStoredYear() {
  return localStorage.getItem(STORAGE_KEY) || null;
}

/** Store year (accepts either "2025" or "2025-2026", normalizes to short) */
export function setStoredYear(year) {
  const short = year ? year.split("-")[0] : null;
  if (short) localStorage.setItem(STORAGE_KEY, short);
  else localStorage.removeItem(STORAGE_KEY);
}

/** Convert short → full: "2025" → "2025-2026" */
export function toFullYear(shortYear) {
  if (!shortYear) return null;
  const y = parseInt(shortYear);
  return isNaN(y) ? shortYear : `${y}-${y + 1}`;
}
